import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "button"]

  copy() {
    const text = this.contentTarget.innerText
    navigator.clipboard.writeText(text).then(() => {
      const btn = this.buttonTarget
      btn.innerHTML = '<i class="bi bi-check2 me-1"></i>Copied!'
      btn.classList.add("btn-success")
      btn.classList.remove("btn-outline-secondary")
      setTimeout(() => {
        btn.innerHTML = '<i class="bi bi-clipboard me-1"></i>Copy'
        btn.classList.remove("btn-success")
        btn.classList.add("btn-outline-secondary")
      }, 2000)
    })
  }
}
